<div *ngFor="let formTemplate of formTemplateList" [value]="formTemplate">
  <mat-card>
    <mat-card-header>
      <mat-card-title>{{ formTemplate.title }}</mat-card-title>
    </mat-card-header>

    <div
      *ngFor="let subTitleContent of formTemplate.sub_title_content"
      [value]="subTitleContent"
    >
      <mat-card-header *ngIf="subTitleContent.sub_title">
        <mat-card-subtitle>{{ subTitleContent.sub_title }}</mat-card-subtitle>
      </mat-card-header>
      <mat-card-content
        fxLayout="row wrap"
        fxLayoutAlign="space-between center"
      >
        <!-- -------------------- -->
        <mat-form-field
          *ngIf="formTemplate.title == 'Taxonomia'"
          appearance="outline"
          fxFlex="49"
          matBadge="{{ speciesValue ? 1 : '' }}"
        >
          <mat-label>Especie</mat-label>
          <mat-select [(ngModel)]="speciesValue">
            <mat-option>Ninguno</mat-option>
            <mat-option
              *ngFor="let speciesItem of speciesList"
              [value]="speciesItem.species_id"
            >
              {{ speciesItem.species_name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <!-- -------------------- -->
        <mat-form-field
          appearance="outline"
          fxFlex="49"
          *ngFor="
            let descriptorSearch of subTitleContent.descriptor_search_list
          "
          [value]="descriptorSearch"
          matBadge="{{ descriptorSearch.selection_value ? 1 : '' }}"
        >
          <mat-label>{{ descriptorSearch.descriptor_label }}</mat-label>

          <input
            *ngIf="descriptorSearch.selection_list.length == 0"
            matInput
            [(ngModel)]="descriptorSearch.selection_value"
          />

          <mat-select
            *ngIf="descriptorSearch.selection_list.length > 0"
            [(ngModel)]="descriptorSearch.selection_value"
            ><mat-option>Ninguna</mat-option>
            <mat-option
              *ngFor="let selectionList of descriptorSearch.selection_list"
              [value]="selectionList.descriptor_category_id"
            >
              {{ selectionList.value }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </mat-card-content>
    </div>
  </mat-card>
  <br />
</div>

<div fxLayout="row">
  <button mat-raised-button color="primary" (click)="fnBuscar()">Buscar</button>

  <button
    mat-stroked-button
    color="primary"
    (click)="fnCacelar()"
    style="margin: 0px 8px"
  >
    Cancelar
  </button>
</div>
<br />
